import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LoadingService } from '../../../../core/services/loading.service';
import { SettingService } from '../../../../core/services/setting.service';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { ActionAlert } from '../../../../core/dto/actionAlert';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AddEditPredefinedCostComponent } from './add-edit-predefined-cost/add-edit-predefined-cost.component';
import { SETTINGS } from '../../../../core/config/common.settings';

@Component({
  selector: 'app-tour-costing',
  templateUrl: './tour-costing.component.html',
  styleUrls: ['./tour-costing.component.scss'],
})
export class TourCostingComponent implements OnInit {
  protected readonly SETTINGS = SETTINGS;

  isMarkUpBefore = true;
  accVatPercentage: number = 0;
  brand: any;
  brandId: any;
  loggedUser: any;
  predefinedCosting: any;
  actionMessage = new ActionAlert();
  markupMessage = new ActionAlert();
  vatMessage = new ActionAlert();

  constructor(
    private settingService: SettingService,
    private authService: AuthService,
    private nzModalService: NzModalService,
    private loading: LoadingService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.loggedUser = this.authService.getLoggedInUser();
    this.findBrand().then();
  }

  async findBrand(): Promise<void> {
    this.brand = await this.settingService.findBrand(this.loggedUser.userId);
    this.brandId = this.brand._id;
    this.isMarkUpBefore = this.brand?.isMarkCostBefore;
    this.accVatPercentage = this.brand?.accVatPercentage ?? 0;
    this.predefinedCosting = this.brand?.predefinedCosting || [];
  }

  onChangeIsMarkup(value: any): void {
    this.isMarkUpBefore = value;
  }

  async updateBrand(): Promise<void> {
    try {
      this.loading.start();
      const payload = {
        _id: this.brandId,
        isMarkCostBefore: this.isMarkUpBefore,
      };
      await this.settingService.updateBrand(payload);
      this.markupMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.markupUpdated'
        ),
        'success'
      );
      this.loading.stop();
    } catch (e) {
      this.markupMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.markupNotUpdated'
        ),
        'error'
      );
      this.loading.stop();
    }
  }

  async updateVatPercentage(): Promise<void> {
    try {
      this.loading.start();
      const payload = {
        _id: this.brandId,
        accVatPercentage: this.accVatPercentage,
      };
      await this.settingService.updateBrand(payload);
      this.vatMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.vatUpdated'
        ),
        'success'
      );
      this.loading.stop();
    } catch (e) {
      this.vatMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.vatNotUpdated'
        ),
        'error'
      );
      this.loading.stop();
    }
  }

  async updatePredefinedCosting(): Promise<void> {
    try {
      this.loading.start();
      const payload = {
        _id: this.brandId,
        predefinedCosting: this.predefinedCosting,
      };
      await this.settingService.updateBrand(payload);
      this.loading.stop();
    } catch (e) {
      this.actionMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.costingNotUpdated'
        ),
        'error'
      );
      this.loading.stop();
    }
  }

  addEditPredefinedCosting(mode: string, data: any, index?: number): void {
    this.nzModalService
      .create({
        nzTitle: this.translocoService.translate(
          'settings.preferences.tourCosting.modal.title'
        ),
        nzWidth: '500px',
        nzContent: AddEditPredefinedCostComponent,
        nzFooter: null,
        nzComponentParams: {
          mode,
          data,
          index,
        },
      })
      .afterClose.subscribe(data => {
        if (data.valid) {
          this.predefinedCosting = data.predefinedCost;
          this.updatePredefinedCosting().then(r => {
            this.ngOnInit();
            const message: string =
              data.mode === this.SETTINGS.PREDEFINED_COST_MODE.NEW
                ? this.translocoService.translate(
                    'settings.preferences.tourCosting.messages.predefinedAdded'
                  )
                : this.translocoService.translate(
                    'settings.preferences.tourCosting.messages.predefinedUpdated'
                  );

            this.actionMessage = new ActionAlert(
              true,
              true,
              message,
              'success'
            );
          });
        }
      });
  }

  deletePredefinedCosting(index: number): void {
    this.predefinedCosting.splice(index, 1);
    this.updatePredefinedCosting().then(r => {
      this.ngOnInit();
      this.actionMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.tourCosting.messages.predefinedDeleted'
        ),
        'success'
      );
    });
  }

  havePredefinedCosting(): boolean {
    const { predefinedCosting } = this.brand || [];
    return predefinedCosting?.length === 0;
  }
  cancel(): void {}
}
